// Ocupa el lugar de la lista cuando el servicio de promociones no se puede leer.
import { AlertTriangle, Lock } from 'lucide-react';
import { ErrorState } from '@/kit';

export type PromotionsServiceStateKind = 'unavailable' | 'forbidden' | 'failed';

const COPY = {
    unavailable: {
        title: 'El servicio de promociones todavía no está disponible',
        description:
            'Este ambiente todavía no tiene el servicio de promos de venta. En cuanto esté disponible, la lista y el historial aparecen solos.',
    },
    forbidden: {
        title: 'No tienes permiso para ver las promos de venta',
        description: 'Pide el permiso al administrador de VentasLuga.',
    },
} as const;

export function PromotionsServiceState({
    kind,
    detail,
    onRetry,
}: {
    kind: PromotionsServiceStateKind;
    detail?: string;
    onRetry?: () => void;
}) {
    if (kind === 'failed') {
        return (
            <ErrorState
                title="No pudimos cargar las promos de venta"
                description={detail}
                onRetry={onRetry}
            />
        );
    }
    const { title, description } = COPY[kind];
    const Icon = kind === 'forbidden' ? Lock : AlertTriangle;
    return (
        <div
            role="alert"
            className="flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-warning-soft-border bg-warning-soft/50 px-6 py-12 text-center"
        >
            <Icon className="size-6 text-warning" aria-hidden />
            <h2 className="text-[14px] font-semibold">{title}</h2>
            <p className="max-w-xl text-[11.5px] leading-relaxed text-muted-foreground">
                {description}
            </p>
        </div>
    );
}
